<template>
  <div>
    <div style="position:sticky; top:-78px;z-index: 99;background: #fff;">
      <swiperComponents :adData="adData"></swiperComponents>
      <div v-if="searchInfo" class="titleRow">
        <div style="display: flex;align-items: center;">
          <img class="plateIcon" :src="require('../../assets/img/platelistIcon.png')" alt="" />
          <span v-if="!searchInfo.name" class="custom-title">全部板块</span>
          <template v-else>
            <span @click="back" style="color: #2A82E4;text-decoration-line: underline;">{{
              searchInfo.parentsName
            }}</span
            >-><span>{{ searchInfo.name }}</span>
          </template>
          <!-- <van-tag v-else style="margin-right:5px;font-weight: 600;" type="danger">{{
          searchInfo.name
        }}</van-tag> -->
        </div>
        <span v-if="searchInfo.onlineCount" class="custom-title"
          >当前在线{{ searchInfo.onlineCount }}人</span
        >
      </div>
      <div class="searchBox">
        <form action="/">
          <van-search
            show-action
            v-model="searchContent"
            placeholder="请输入搜索关键词"
            @search="onSearch"
            @clear="onSearch"
          >
            <template #action>
              <div class="searchbtn" @click.stop="onSearch">搜索</div>
            </template>
          </van-search>
        </form>

        <div
          style="display:flex;align-items: center;justify-content: space-around;flex-wrap: wrap;"
        >
          <van-radio-group
            @change="toggle"
            class="searchTypeClass"
            v-model="searchType"
            direction="horizontal"
          >
            <van-radio class="radiaodiy" name="title">主题</van-radio>
            <van-radio class="radiaodiy" name="author">作者</van-radio>
            <van-radio class="radiaodiy" name="content">内容</van-radio>
          </van-radio-group>
          <van-checkbox
            @click="listsortTime"
            v-model="sortTime"
            class="searchTypeClass"
            shape="square"
            >按时间</van-checkbox
          >
          <div
            @click="checkboxShow = true"
            style="font-size:13px;margin-top: 8px;flex: 1;text-align: right;position: relative;"
          >
            <!-- <select @change="selType" style="font-size:15px" v-model="type">
            <option :value="null">全部帖子</option>
            <option :value="4">只看成交</option>
            <option :value="1">只看求购</option>
            <option :value="2">只看出售</option>
          </select> -->
            {{ getTypeName() }}
            <van-icon name="arrow" />
          </div>
        </div>
      </div>
    </div>

    <van-popup
      position="center"
      :style="{
        fontSize: '25px',
        width: '80%',
        // position: 'absolute',
        // right: '3px',
        // top: '170px',
      }"
      v-model="checkboxShow"
    >
      <div style="padding: 5px; ">
        <van-checkbox-group v-model="types" ref="checkboxGroup">
          <!-- <van-checkbox style="margin-bottom: 5px;" shape="square" :name="4">只看成交</van-checkbox>
          <van-checkbox style="margin-bottom: 5px;" shape="square" :name="1">只看求购</van-checkbox>
          <van-checkbox style="margin-bottom: 5px;" shape="square" :name="2">只看出售</van-checkbox> -->

          <van-cell-group>
            <van-cell
              size="large"
              v-for="(item, index) in checkboxGroup"
              clickable
              :key="index"
              :title="item.title"
              @click="checkboxGroupToggle(index)"
            >
              <template #right-icon>
                <van-checkbox shape="square" :name="item.type" ref="checkboxes" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
        <van-button type="info" @click="selType" block size="small">确认</van-button>
      </div>
    </van-popup>
    <!-- 只有 联体钞/纪念钞 Y003002
    普通纪念币  Y003007
    评级币/评级钞 Y003016 显示 -->
    <div
      class="downLoadApp"
    >
    公众号：一尘盯盘助手
      <!-- <img class="dlIMG" src="../../assets/img/downloadApp.png" alt="" /> -->
    </div>
    <van-pull-refresh
      class="van-pull-refresh"
      style="min-height: 100vh;"
      v-model="refreshing"
      @refresh="onRefresh"
      :disabled="pullRefreshDisabled"
    >
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <template v-for="(item, index) in list">
          <item :item="item" :type="1" :key="index"></item>
        </template>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import {
  plateList,
  plateSearch,
  getSubPostIds,
  subscribe,
  cancelSubscribe,
  wxuser,
  yichenLoginEx,
} from '@/api/base';
import swiperComponents from '../components/swiper.vue';
import item from '../components/item';
import { getTimeShow } from '@/utils/index';
export default {
  name: 'plateList',
  components: {
    item,
    swiperComponents,
  },
  data() {
    return {
      refreshing: false,
      loading: false,
      finished: false,
      sortTime: false,
      checkboxShow: false,
      checkboxGroup: [
        { title: '只看成交', type: 4 },
        { title: '只看求购', type: 1 },
        { title: '只看出售', type: 2 },
      ],
      page: {
        rows: 10,
        current: 1,
        scrollid: null,
      },
      list: [],
      searchType: 'title',
      searchInfo: null,
      searchContent: null,
      subPostIds: [],
      type: [],
      types: [],
      isVip: false,
      isSearch: false,
      pullRefreshDisabled: false,
      adData: this.$store.state.app.adBanner.smallList,
    };
  },
  computed: {
    // isVip() {
    //   return !this.$store.state.app.userinfos.isVip == 0;
    // },
  },
  created() {
    this.init();
    document.addEventListener('gesturestart', function(event) {
      event.preventDefault();
    });
  },
  activated() {
    if (this.$route.query.id != this.searchInfo.id) {
      this.init(true);
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    getTimeShow,
    back() {
      window.history.back();
    },
    handleDownloadApp() {
      window.location.href = 'https://h5.yichenbao.cn/#/pagesB/dowloadApp/index';
    },
    init(status) {
      window.scrollTo(0, 0);
      console.log(this.$route.query);
      this.searchContent = null;
      if (this.$route.query.searchContent) {
        this.searchContent = this.$route.query.searchContent;
      }
      getSubPostIds({ openId: window.openId }).then(res => {
        this.subPostIds = res.data;
      });
      this.searchInfo = this.$route.query;
      console.log(this.$route.query);
      if (status) {
        //
        this.list = [];
        this.page = { rows: 10, current: 1, scrollid: null };
        this.onLoad();
      }

      if (
        this.$store.state.app.userinfos.isVip == 1 &&
        this.$store.state.app.userinfos.vipExpireTime
      ) {
        this.isVip = true;
      } else {
        this.isVip = false;
      }
    },
    async onLoad() {
      // this.$toast.loading({
      //   duration: 0, // 持续展示 toast
      //   forbidClick: true,
      //   message: '...',
      // });
      let filter = {
        sectionCode: this.$route.query.code,
        field: this.searchType,
        types: this.type.length > 0 ? this.type : null,
      };
      let query = {
        indexname: 'post',
        keyWords: this.searchContent,
        ...this.page,
        sort: this.sortTime ? 'lastupdatetime' : 'disp', //disp
      };
      await plateList({
        filter: filter,
        query: query,
        // searchContent: this.searchContent,
      }).then(res => {
        res.data.data.map(item => {
          return (item.subscribe = this.subPostIds.indexOf(item.id) != -1 ? true : false);
        });
        let tmpList = res.data.data;
        let list = this.list || [];
        if (this.refreshing) {
          list = tmpList;
          this.refreshing = false;
        } else if (tmpList.length) {
          list = [...list, ...tmpList];
        } else {
          this.finished = true;
        }

        this.loading = false;

        this.list = list;
        this.page.scrollid = res.data.scrollid;
        this.page.current++;
        // this.$toast.clear();
      });
    },
    onSearch() {
      if (
        this.$store.state.app.userinfos.isVip == 1 &&
        this.$store.state.app.userinfos.vipExpireTime
      ) {
        let searchType;
        switch (this.searchType) {
          case 'title':
            searchType = '1';
            break;
          case 'author':
            searchType = '2';
            break;
          case 'content':
            searchType = '3';
            break;
          default:
            break;
        }
        plateSearch({
          sectionCode: this.$route.query.code,
          searchType: searchType,
          searchContent: this.searchContent,
        }).then(res => {
          // this.list = res.data.records;
          // this.loading = false;
          // this.onLoad();
          this.refreshing = false;
          this.list = [];
          this.page = { rows: 10, current: 1, scrollid: null };
          this.finished = false;

          this.onLoad();
        });
      } else {
        this.$dialog
          .confirm({
            title: '暂未开通会员',
            confirmButtonText: '开通会员',
            cancelButtonText: '取消',
          })
          .then(() => {
            // on confirm
            this.$router.push({ path: '/vip', query: { item: new Date().getTime() } });
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    toggle() {
      this.refreshing = false;
      this.list = [];
      this.finished = false;
      this.page = { rows: 10, current: 1, scrollid: null };
      this.onLoad();
    },
    selType() {
      if (!this.isVip) {
        this.type = [];
        this.$dialog
          .confirm({
            title: '暂未开通会员',
            confirmButtonText: '开通会员',
            cancelButtonText: '取消',
          })
          .then(() => {
            // on confirm
            this.$router.push({ path: '/vip', query: { item: new Date().getTime() } });
          })
          .catch(() => {
            // on cancel
          });
      } else {
        let arr = [];
        this.types.map(item => {
          arr.push(item);
          if (item == 2) {
            arr.push(0);
          }
        });
        this.type = arr;
        this.toggle();
      }
      this.checkboxShow = false;
    },
    checkboxGroupToggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    getTypeName() {
      if (this.type.length == 0 || this.type.length == 4) {
        return '全部帖子';
      } else {
        let str = '';
        this.type.map((item, index) => {
          if (item == 4) {
            str += '成交';
          }
          if (item == 1) {
            str += '求购';
          }
          if (item == 2) {
            str += '出售';
          }
          if (index == 0) {
            str += '/';
          }
        });
        return str;
      }
    },
    showOpenVip() {
      if (!this.isVip) {
        this.$dialog
          .confirm({
            title: '暂未开通会员',
            confirmButtonText: '开通会员',
            cancelButtonText: '取消',
          })
          .then(() => {
            // on confirm
            this.$router.push({ path: '/vip', query: { item: new Date().getTime() } });
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    listsortTime(e) {
      console.log(e);
      if (!this.isVip) {
        this.sortTime = false;
        this.$dialog
          .confirm({
            title: '暂未开通会员',
            confirmButtonText: '开通会员',
            cancelButtonText: '取消',
          })
          .then(() => {
            // on confirm
            this.$router.push({ path: '/vip', query: { item: new Date().getTime() } });
          })
          .catch(() => {
            // on cancel
          });
      } else {
        this.onRefresh();
      }
    },
    onRefresh(refreshing = true) {
      this.list = [];
      this.refreshing = refreshing;
      this.finished = false;
      this.page = { rows: 10, current: 1, scrollid: null };
      document.documentElement.scrollTop = 0;
      window.pageYOffset = 0;
      document.body.scrollTop = 0;
      this.onLoad();
    },
    goBack(item) {
      window.location.href = `${item.lasturl}`;
    },
    setSubscribe(item) {
      subscribe({ postId: item.id }).then(res => {
        this.$toast('关注成功');
        item.subscribe = true;
      });
    },
    cancelSubscribe(item) {
      this.$dialog
        .confirm({
          title: '',
          message: '是否取消关注',
        })
        .then(() => {
          // on confirm
          cancelSubscribe({ postId: item.id }).then(res => {
            this.$toast('已取消关注');
            item.subscribe = false;
          });
        })
        .catch(() => {
          // on cancel
        });
    },

    handleScroll() {
      let scrollTop =
        window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // 滚动条滚动的距离
      let scrollStep = scrollTop - this.oldScrollTop;
      // 更新——滚动前，滚动条距文档顶部的距离
      this.oldScrollTop = scrollTop;

      //变量windowHeight是可视区的高度
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

      //滚动条到底部的条件
      if (scrollTop + windowHeight == scrollHeight) {
        //你想做的事情
        console.log('header  你已经到底部了');
      }
      if (scrollStep < 0) {
        console.log('header 滚动条向上滚动了！');
      } else {
        console.log('header  滚动条向下滚动了！');
        this.pullRefreshDisabled = true;
      }
      // 判断是否到了最顶部
      if (scrollTop <= 0) {
        this.pullRefreshDisabled = false;
        console.log('header 到了最顶部');
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>
<style lang="less" scoped>
.titleRow {
  display: flex;
  font-size: 14px;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  box-sizing: border-box;
  background: linear-gradient(0deg, #fff1eb 0%, #ace0f9 100%);
  .plateIcon {
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
}
.searchTypeClass:first-child {
  margin-left: 10px;
}
.searchTypeClass {
  margin-top: 10px;
  /* margin-left: px; */
  font-size: 13px;
  justify-content: space-around;
}
.itemBox {
  background: #fff;
  margin-top: 10px;
  padding: 10px;
}
.itemBox .title {
  display: flex;
  align-items: center;
  position: relative;
  font-size: 16px;
  padding-right: 40px;
}
.itemBox .follow {
  position: absolute;
  display: block;
  right: 0px;
  top: -10px;
  padding: 10px;
}
.itemBox .custom-title {
  margin-left: 10px;
  white-space: nowrap; /* 规定文本是否折行 */
  overflow: hidden; /* 规定超出内容宽度的元素隐藏 */
  text-overflow: ellipsis;
  font-size: 13px;
  color: #383838;
}
.itemBox .desc {
  margin-top: 5px;
  display: flex;
  color: #969799;
  font-size: 13px;
  justify-content: space-around;
}
.itemBox .desc:first-child {
  margin-top: 10px;
}
.desc .custom-titl {
  flex: 1;
  white-space: nowrap; /* 规定文本是否折行 */
  overflow: hidden; /* 规定超出内容宽度的元素隐藏 */
  text-overflow: ellipsis;
}
.van-pull-refresh {
  /* height: calc(100vh - 100px) !important;
  overflow: auto !important; */
}

.searchBox {
  padding-top: 4px;
  box-sizing: border-box;
  background: #e5e5e5;
  border: 0.3px solid #e5e5e5;
  padding-bottom: 9px;
  .van-search {
    background: #fff;
    font-size: 20px;
    padding: 3px 0;
    border: 1px solid #e5e5e5;
    box-shadow: 0px 0px 25.5px #f2f5e9;
    border-radius: 5px;

    .van-search__content {
      background: transparent;
    }
  }
  .searchbtn {
    width: 65px;
    font-size: 16px;
    height: 30px;
    opacity: 1;
    border-radius: 8px;
    background: linear-gradient(
      45deg,
      #ff8177 0%,
      #ff867a 0%,
      #ff8c7f 21%,
      #f99185 52%,
      #cf556c 78%,
      #b12a5b 100%
    );
    text-align: center;
    line-height: 30px;
    color: #fff;
  }
}

.downLoadApp {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  font-size: 14px;
  background: #c55168;
  color: #fff;
  .dlIMG {
    display: block;
    width: 18px;
    height: 18px;
    margin-left: 10px;
  }
}
</style>
<style>
.radiaodiy .van-radio__icon {
  background: #fff;
  border-radius: 50%;
}
.searchTypeClass .van-checkbox__icon {
  background: #fff;
}
</style>
